<template>
  <section class="mt-3">
    <div v-if="!reportMode">
      <div class="mx-1 button_container">
        <b-button v-if="filter.mode === 'MEASURES'" variant="default" @click="euroButtonClick()">
          <img title="Visualizza costi" src="/static/icons/icon-6.png" width="16" />
        </b-button>
        <!-- <b-button v-if="filter.mode === 'MEASURES' " variant="default" @click="measuresButtonClick()">
          <img title="Visualizza misure" src="/static/icons/icon-26.png" width="16">
        </b-button> -->
      </div>
    </div>
    <div :style="{ height: checkChartHeight }" :id="chartId"></div>
  </section>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import NeedUpdateMixin from "../../NeedUpdateMixin";
import { makeid } from "../../helpers";
import { startRender, finishRender } from "../../../../helpers/printReady";

export default {
  name: "AmRadarChart",
  mixins: [NeedUpdateMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    reportMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      chartId: makeid(),
      chart: undefined,
    };
  },
  mounted() {
    this.reload();
  },
  beforeDestroy() {
    this.unload();
  },
  methods: {
    async reload() {
      try {
        if (!this.filter.channels.length) {
          return;
        }
        this.unload();
        let data = await this.$store.dispatch("charts/get", this.filter);

        let total = 0;
        let series = [];
        data.columns.forEach((c, i) => {
          if (i == 0) return;

          let value = 0;
          data.values.forEach((v) => {
            value += v[i];
          });
          value = value.toFixed(3);
          total += value;

          const mu = data.mus[i - 1];

          series.push({
            name: `${c}`,
            unit: ` ${mu}`,
            value,
          });
        });

        this.drawChart(series);
        this.$store.commit("stopLoading");
      } catch (error) {
        console.log(error.message);
        this.$store.commit("stopLoading");
      }
    },

    drawChart(series) {
      var chart = am4core.create(this.chartId, am4charts.RadarChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      setTimeout(settleRender, 8000);

      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      // chart.numberFormatter.numberFormat = "#.0";

      /* Add data */
      chart.data = series;

      if (this.reportMode) {
        chart.fontSize = 10;
      }

      chart.cursor = new am4charts.RadarCursor();
      /* Create axes */
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "name";
      categoryAxis.cursorTooltipEnabled = false;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
      valueAxis.renderer.axisFills.template.fillOpacity = 0.05;
      valueAxis.cursorTooltipEnabled = false;

      /* Create and configure series */
      var series = chart.series.push(new am4charts.RadarSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "name";
      series.strokeWidth = 3;
      series.tooltipText = "{name} [[{unit}]]: [bold] {valueY.value}";
      series.tooltip.label.propertyFields.fill = am4core.color("#FFFFFF");
      series.tooltip.getFillFromObject = false;
      series.tooltip.autoTextColor = false;
      series.tooltip.label.fill = am4core.color("black");

      var bullet = series.bullets.push(new am4charts.CircleBullet());
    },

    euroButtonClick() {
      this.filter.costs = !this.filter.costs;
      this.reload();
    },

    unload() {
      if (this.chart) {
        this.chart.dispose();
      }
      this.chart = undefined;
    },
  },
  watch: {
    filter() {
      _.debounce(this.reload, 10)();
    },
  },
  computed: {
    checkChartHeight() {
      if (this.reportMode) {
        return "100%";
      } else {
        return "100%";
      }
    },
  },
};
</script>

<style scoped>
.button_container {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/Radar.vue